import { MgmMainPageResources } from "@/src/member-get-member/MainPage/MgmMainPage.Resources";

export const MgmLandingPageResources = {
    goodieAdvantagesTitle: "<b>Zalety</b> goodie cashback",

    lpDashboard: {
        title: "Polecaj i <b>zarabiaj</b>",
        recommendedLabel: "Polecaj goodie cashback znajomym i łapcie bonusy!",
        bonusLabel: MgmMainPageResources.dashboard.bonusDescription,
        signUpLabel: "Zarejestruj się lub zaloguj i zacznij polecać.",
        loginText: "Zaloguj",
        registerText: "Utwórz konto",
    },
};
